import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

import { TableHeader } from "@/models/table";
import { useSearchPageStore } from "@/store/store/searchPageStore";
import { CertificationSearchResultModel } from "@/types/certifications";
import { DisbursementSearchResultModel } from "@/types/disbursements";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPageSearchResultsTableRow',
  props: {
    result: {},
    headers: {}
  },
  setup(__props: any) {

const props = __props;

const searchPageStore = useSearchPageStore();

const route = useRoute();

function handleTableRowClick() {
  searchPageStore.handleSearchResultClick(props.result);
}

function getResultUrl(result: CertificationSearchResultModel | DisbursementSearchResultModel) {
  const page = searchPageStore.searchPageState.pageName;
  const id = searchPageStore.getRouteIdentifier(page,result);
  window.open(`/${page}/${id}`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", {
    onClick: handleTableRowClick,
    onContextmenu: _cache[0] || (_cache[0] = ($event: any) => (getResultUrl(props.result)))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headers, (header) => {
      return (_openBlock(), _createElementBlock("td", {
        key: header[`${header.key}`]
      }, _toDisplayString(__props.result[`${header.key}`]), 1))
    }), 128))
  ], 32))
}
}

})